module.exports = __webpack_public_path__ + "static/media/06_720.29685de3.jpeg";